import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { PeopleService } from '../../shared/services';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  constructor() {}

  // apply translations to an object
  // object : the object where to apply translations
  // translations : object of form { translationKey : { lang : value } }
  //      where translation key of form '{pathToProperty}'
  //                                 or '{childId}.{pathToProperty}'
  //                                 or '{parentId}/{childId}.{pathToProperty}
  public applyTranslations(object: any, translations: any, lang: string) {
    if (!translations) {
      return;
    }
    const allObjects = this.getObjectsWithId(object, ['sectionsItems']);
    _.forOwn(translations, (value, key: string) => {
      if (!key || !value) {
        return;
      }
      const newValue = value[lang];
      if (newValue) {
        if (key.indexOf('/') >= 0) {
          // key is of the form '{parentId}/{childId}.{path}'
          const split = key.split('/', 2); // returns [ parent, childIdAndPath ]
          const objArr = allObjects[split[0]];
          _.forEach(objArr, (parent) => {
            this.applyTranslation(split[1], newValue, this.getObjectsWithId(parent, ['sectionsItems']));
          });
        } else {
          this.applyTranslation(key, newValue, allObjects);
        }
      }
    });
  }

  private applyTranslation(key: any, newValue: any, allObjectsWithId: any) {
    const index = key.indexOf('.');
    if (index > -1) {
      const id = key.substr(0, index);
      const path = key.substr(index + 1);
      if (path) {
        const objArr = allObjectsWithId[id];
        _.forEach(objArr, (element) => {
          const oldValue = _.get(element, path);
          const oldPath = path + '_old';
          // !_.has(element, oldPath) : if a translations has been applied before, do not reapply it,
          // as there is a risk of overriding newer data
          if (oldValue && !_.has(element, oldPath)) {
            _.set(element, oldPath, oldValue);
            _.set(element, path, newValue);
          }
        });
      }
    }
  }

  private getObjectsWithId(object: any, forbiddenProps = [], allObjectsWithId: any = {}, done = new WeakMap()) {
    if (!object || typeof object !== 'object' || done.has(object)) {
      return allObjectsWithId;
    }
    if (object.id) {
      if (allObjectsWithId[object.id]) {
        allObjectsWithId[object.id].push(object);
      } else {
        allObjectsWithId[object.id] = [object];
      }
    } else if (object.Id) {
      if (allObjectsWithId[object.Id]) {
        allObjectsWithId[object.Id].push(object);
      } else {
        allObjectsWithId[object.Id] = [object];
      }
    }
    done.set(object, true);
    _.forIn(object, (value, key: string) => {
      if (value && typeof value === 'object' && !done.has(value) && forbiddenProps.indexOf(key) < 0) {
        this.getObjectsWithId(value, forbiddenProps, allObjectsWithId, done);
      }
    });
    return allObjectsWithId;
  }
}
